import * as yup from "yup";
import { definedDecimalStr } from "utils/schemas/decimalStr";
import { formatCurrency } from "utils/formatting";

export const name = yup
  .string()
  .trim()
  .label("Product Line Name")
  .required()
  .max(255);

export const shortName = yup
  .string()
  .trim()
  .label("Product Line Name (Short)")
  .max(15)
  .default(null)
  .nullable();

export const DEFAULT_NAME_SEPARATOR = ":";

export const nameSeparator = yup
  .string()
  .label("Name Separator")
  .transform((v: string | null | undefined) =>
    v === null ? undefined : v?.replace(/\s{2,}/, " ")?.trimEnd(),
  )
  .default(DEFAULT_NAME_SEPARATOR)
  .max(5)
  .required();

export const isInternalSkuIdAppended = yup
  .bool()
  .label("Append Internal SKU ID?")
  .default(false);

export const productCategoryIds = yup
  .array()
  .of(yup.string().uuid().required())
  .label("Product Categories");

export const shipsFromZip = yup
  .string()
  .label("Ships from ZIP")
  .trim()
  .defined()
  .default(null)
  .nullable()
  .matches(/^\d{5}$/, {
    message: "Must be a valid 5-digit zip code",
    excludeEmptyString: true,
  });

export const manufacturingFacilityId = yup
  .string()
  .label("Manufacturing Facility")
  .uuid()
  .nullable()
  .defined()
  .default(null);

export const wholesaleUnitPrice = definedDecimalStr({
  numberFormatter: formatCurrency,
})
  .min(0)
  .max(10000)
  .label("Default Wholesale Unit Price for SKUs");

export const INNER_CASE_QUANTITY_LABEL = "Inner Case Quantity";

export const innerCaseQuantity = yup
  .number()
  .label(INNER_CASE_QUANTITY_LABEL)
  .nullable()
  .defined()
  .default(null)
  .min(1)
  .max(32767);

export const wholesaleCaseQuantity = yup
  .number()
  .label("Wholesale Case Quantity")
  .nullable()
  .defined()
  .default(null)
  .min(1)
  .max(32767)
  .when("innerCaseQuantity", {
    is: (v: unknown) => v !== null,
    then: (s) =>
      s.required(
        `\${label} is required when an ${INNER_CASE_QUANTITY_LABEL} is provided.`,
      ),
  });
